import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
import {
  DEFAULT_SELECTABLE_OPTION_CARD_DISABLED,
  DEFAULT_SELECTABLE_OPTION_CARD_ICON,
  DEFAULT_SELECTABLE_OPTION_CARD_ICON_SET,
  DEFAULT_SELECTABLE_OPTION_CARD_SELECTED,
  SelectableOptionCardIconSet,
} from './selectable-option-card.types';

@Component({
  selector: 'app-selectable-option-card',
  templateUrl: './selectable-option-card.component.html',
  styleUrls: ['./selectable-option-card.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SelectableOptionCardComponent implements OnChanges {
  @Input() icon = DEFAULT_SELECTABLE_OPTION_CARD_ICON;
  @Input() iconSet: SelectableOptionCardIconSet = DEFAULT_SELECTABLE_OPTION_CARD_ICON_SET;
  @Input() label = '';
  @Input() description = '';
  @Input() ariaLabel = '';
  @Input() selected = DEFAULT_SELECTABLE_OPTION_CARD_SELECTED;
  @Input() disabled = DEFAULT_SELECTABLE_OPTION_CARD_DISABLED;

  @Output() selectedChange = new EventEmitter<boolean>();

  computedRootClasses = '';

  ngOnChanges(_: SimpleChanges): void {
    this.computedRootClasses = ['munily-selectable-option-card', this.selected ? 'is-selected' : '', this.disabled ? 'is-disabled' : '']
      .filter(Boolean)
      .join(' ');
  }

  toggle(): void {
    if (this.disabled) return;
    this.selectedChange.emit(!this.selected);
  }
}
